export default function Marquee({ items, className = "" }) {
    return (
        <div data-testid="marquee" className={`overflow-hidden border-y py-4 sm:py-5 ${className}`}>
            <div className="flex w-max animate-marquee">
                {[0, 1].map((dup) => (
                    <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
                        {items.map((item, i) => (
                            <span key={i} className="flex items-center whitespace-nowrap">
                                <span className="px-6 font-sans text-xs font-semibold uppercase tracking-[0.3em] sm:px-10 sm:text-sm">
                                    {item}
                                </span>
                                <span className="inline-block h-1.5 w-1.5 rotate-45 rounded-[1px] bg-current opacity-60" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
